module.exports = __webpack_public_path__ + "static/media/clock.0ef9b091.svg";